import { render, staticRenderFns } from "./DashboardConventionsFilters.vue?vue&type=template&id=d67e1562&scoped=true"
import script from "./DashboardConventionsFilters.vue?vue&type=script&lang=js"
export * from "./DashboardConventionsFilters.vue?vue&type=script&lang=js"
import style0 from "./DashboardConventionsFilters.vue?vue&type=style&index=0&id=d67e1562&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67e1562",
  null
  
)

export default component.exports